export default __webpack_public_path__ + "static/media/karen_profile.3b4ec60a.png";